import { LS_PORTFOLIO_PREFS_STORAGE } from "@/zapi-frontend/shared/local-storage/keys";
import type { TPortfolioPrefs } from "./portfolioStorage";

type TStoredPrefsByOrg = Record<string, TPortfolioPrefs>;

function readStore(): TStoredPrefsByOrg {
  try {
    const raw = localStorage.getItem(LS_PORTFOLIO_PREFS_STORAGE);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? (parsed as TStoredPrefsByOrg) : {};
  } catch {
    return {};
  }
}

export function loadPortfolioPrefs(organizationId: number): TPortfolioPrefs | null {
  if (!organizationId) return null;
  return readStore()[String(organizationId)] ?? null;
}

export function savePortfolioPrefs(organizationId: number, prefs: TPortfolioPrefs): void {
  if (!organizationId) return;
  try {
    const store = readStore();
    store[String(organizationId)] = prefs;
    localStorage.setItem(LS_PORTFOLIO_PREFS_STORAGE, JSON.stringify(store));
  } catch {
    return;
  }
}
